import { Phone, MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";

const PHONE = "tel:+41766388655";
const WHATSAPP =
  "https://wa.me/41766388655?text=Bonjour%2C%20je%20souhaite%20obtenir%20un%20devis%20pour%20%5Bpr%C3%A9ciser%5D";

const FloatingCTA = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const atBottom =
        window.innerHeight + window.scrollY >= document.body.scrollHeight - 200;
      setVisible(!atBottom);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40 hidden md:flex flex-col gap-3">
      {/* WhatsApp */}
      <a
        href={WHATSAPP}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative w-14 h-14 rounded-full flex items-center justify-center text-white shadow-lg transition-transform hover:scale-110"
        style={{ backgroundColor: "#25D366" }}
        aria-label="Devis Rapide par WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
        <span className="absolute right-full mr-3 whitespace-nowrap bg-foreground text-background text-xs font-medium px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Devis Rapide
        </span>
      </a>

      {/* Téléphone */}
      <a
        href={PHONE}
        className="group relative w-14 h-14 rounded-full flex items-center justify-center text-white shadow-lg transition-transform hover:scale-110"
        style={{ backgroundColor: "#0066CC" }}
        aria-label="Appel Direct"
      >
        <Phone className="w-6 h-6" />
        <span className="absolute right-full mr-3 whitespace-nowrap bg-foreground text-background text-xs font-medium px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Appel Direct
        </span>
      </a>
    </div>
  );
};

export default FloatingCTA;
